export const PAGE_TYPES = {
  HOMEPAGE: 'homepage',
  ABOUT_US: 'about-us',
  ACKNOWLEDGMENT: 'acknowledgment'
};
